<template>
  <div class="famousTeaSpecialarea">
    <Listbox :props-titile="title">
      <div>
        <iframe ref="iframe" :src="iframeSrc" width="100%" height="880" class="iframeBox" />
      </div>
    </Listbox>
  </div>
</template>
<script>
import Listbox from '@/views/common/listbox';
import ENVIRONMENT from '@/utils/environment';
export default {
  name: 'Module',
  components: {
    Listbox
  },
  data: () => {
    return {
      iframeSrc: '',
      title: ''
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.title = route.query.name;
        this.iframeSrc = ENVIRONMENT.BASE_URL + '/moduleResult/' + route.params.id;
      },
      immediate: true
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
</style>

